'use client';
import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { site } from '@/lib/site-content';
import { SiteLogo } from '@/components/site-logo';

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const menuButton = useRef<HTMLButtonElement>(null);
  const path = usePathname();
  const links = [['/solutions/', 'Solutions'], ['/services/', 'Services'], ['/about/', 'About BEDA'], ['/contact/', 'Contact']];

  useEffect(() => {
    if (!open) return;
    const dismiss = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;
      setOpen(false);
      menuButton.current?.focus();
    };
    document.addEventListener('keydown', dismiss);
    return () => document.removeEventListener('keydown', dismiss);
  }, [open]);

  return <>
    <a className="skip-link" href="#main-content">Skip to content</a>
    <div className="topbar"><div className="wrap"><span>Medical equipment & technical support across Tanzania</span><a href={'tel:' + site.phone}><Phone size={13} />{site.phoneDisplay}</a></div></div>
    <header className="site-header"><div className="wrap nav-inner">
      <a className="brand" href="/" aria-label="BEDA Healthcare home"><SiteLogo priority /></a>
      <nav className={open ? 'main-nav is-open' : 'main-nav'} id="main-navigation" aria-label="Main navigation">
        {links.map(([href, label]) => <a key={href} href={href} aria-current={path?.startsWith(href.slice(0, -1)) ? 'page' : undefined} onClick={() => setOpen(false)}>{label}</a>)}
        <a href="/contact/" className="button primary nav-mobile-cta" onClick={() => setOpen(false)}>Request a quotation</a>
      </nav>
      <a href="/contact/" className="button primary nav-cta" aria-label="Request a quotation"><span className="nav-cta-label">Request a quotation</span><span className="nav-cta-short">Request quote</span></a>
      <Button ref={menuButton} variant="ghost" className="menu-toggle" aria-controls="main-navigation" aria-expanded={open} aria-label={open ? 'Close navigation' : 'Open navigation'} onClick={() => setOpen(value => !value)}>{open ? 'Close' : 'Menu'}</Button>
    </div></header>
  </>;
}
